// @ts-check

import ResetGridLink from "~/components/Shared/DataGrid/ResetGridLink";
import { useMembersDataGridContext } from '~/components/AdminPages/MembersDataGrid/MembersDataGrid.context';
import { DEFAULT_SORT_MODEL, EventNames } from '~/components/AdminPages/MembersDataGrid/MembersDataGrid.utils';

export default function ResetMembersGridLink() {
    const { settings } = useMembersDataGridContext();

    return (
        <ResetGridLink
            settings={settings}
            resetTableEventName={EventNames.RESET_TABLE}
            defaultSortModel={DEFAULT_SORT_MODEL}
        />
    );
}
